import { RmsLoadingSpinnerService } from './rms-loading-spinner.service';
import { Injectable } from '@angular/core';

@Injectable()
export class RmsLoadingService {
  static NO_KEY: string = "NO_KEY";

  private loading = {};

  constructor(private rmsLoadingSpinnerService: RmsLoadingSpinnerService) { }

  setLoading(options: any) : Promise<any> { 
    if (typeof options === 'string')   {
      options = { message: options };
    }
    if (!options.key) {
      options.key = RmsLoadingService.NO_KEY;
      this.rmsLoadingSpinnerService.showModal(options.message);
    } else {
      if (this.loading[options.key]) {
        this.loading[options.key].isLoading = true;
        this.loading[options.key].message = options.message;
      } else {
        this.loading[options.key] = { isLoading: true, message: options.message };
      }
    }

    return new Promise<any>((resolve, reject) => {
      if (options.cbPromise instanceof Promise) {
        console.log('setLoading', 'executing callback');

        options.cbPromise.then((data) => {      
          console.log('setLoading.cbPromise', data);
          resolve(data);
        }).catch((error) => reject(error)).finally(() => this.setNotLoading(options.key));
      } else {
        resolve(true);
      }
    });
  }
  
  setNotLoading(key?: string) {
    if (!key) {
      this.rmsLoadingSpinnerService.hideModal();
    } else {
      console.log('setNotLoading', key);
      this.loading[key].isLoading = false;
      this.loading[key].message = '';
    }
  }

  isSectionLoading(key?: string) {
    if (!key) {
      key = RmsLoadingService.NO_KEY;
    }
    if (!this.loading[key]) {
      this.loading[key] = {};
    }

    return this.loading[key] && this.loading[key].isLoading;
  }

  sectionLoadingMessage(key?: string) {
    if (!key) {
      key = RmsLoadingService.NO_KEY;
    }
    if (!this.loading[key]) {
      this.loading[key] = {};
    }

    return this.loading[key].message || '';
  }

  get isLoading() {
    return (Object.keys(this.loading).filter((key) => this.loading[key] && this.loading[key].isLoading)).length > 0;
  }
}
